import React, { Component } from 'react';
import '../App.css';

//theming
import {teal700,blue} from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

//components

import Paper from 'material-ui/Paper';
import {Tabs, Tab} from 'material-ui/Tabs';
// From https://github.com/oliviertassinari/react-swipeable-views
import SwipeableViews from 'react-swipeable-views';

//custom components
import SimpleLinkButton from './SimpleLinkButton';
import Education from './Education';
import Experience from './Experience';
import ReferencesCard from './ReferencesCard';
import SkillCard from './SkillCard';
import SummaryCard from './SummaryCard';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: teal700,
    primary2Color: blue
  },
});
const styles = {
  appbar:{

  },
  hidden:{
    display:'none'
  },
  none:{},
  paper:{
    maxWidth:800,
    margin:'auto',
    marginTop:15,
    marginBottom:15,
    textAlign:'left',
    backgroundColor:'rgba(255,255,255,0)',
  },
  headline: {
    fontSize: 24,
    fontWeight: 400,
    textAlign:'center'
  },
  tab_inkbar:{
    backgroundColor:'rgb(212,175,55)',
  }
};

class Main extends Component {
  constructor(props){
    super(props);
    this.state=props.appState;
  }
  componentWillMount(){
    this.setState({slideIndex:0});
  }
  gotoPDF(){
    window.location.href='http://johnsma.com.s3-website-us-east-1.amazonaws.com/docs/JohnMa-simple.pdf';
  }
  gotoResume(){
    this.props.history.push('/resume');
  }
  gotoResumeExpanded(){
    this.props.history.push('/resumeexpanded');
  }
  handleTabChange = (value) => {
    this.setState({
      slideIndex: value,
    });
  };

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <div className="App background-repeat-light">
            <div className="App-header background-repeat-dark">
              <div>
                {/*<div className="blockinline portrait-main">
                  <img className="portrait" height="75" src="images/wisc.jpg" />
                </div>
                */}
                <div className="blockinline">
                  <h1>John S. Ma</h1>
                  <p>
                    <a
                      className="email-link"
                      href="mailto:johnma30@gmail.com?Subject=Resume%20Inquiry" target="_top"
                    >
                      contact
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <Tabs
              inkBarStyle={styles.tab_inkbar}
              onChange={this.handleTabChange}
              value={this.state.slideIndex}
            >
              <Tab label="Summary" value={0} />
              <Tab label="Experience" value={1} />
              <Tab label="Education" value={2} />
            </Tabs>
            <SwipeableViews
              index={this.state.slideIndex}
              onChangeIndex={this.handleTabChange}
            >
              <div
                className="no-overflow-x"
                style={this.state.slideIndex!==0?styles.hidden:styles.none}
              >
                <div className="single-link">
                  <SimpleLinkButton
                    gotoResume={()=>this.gotoResume()}
                    gotoResumeExpanded={()=>this.gotoResumeExpanded()}
                    gotoPDF={()=>this.gotoPDF()}
                  />
                </div>
                {/*<div className="single-link">
                  <a href="#/resume">
                    resume
                  </a>
                </div>
                <div className="single-link2">
                  <a href="#/resumeexpanded">
                    resume expanded
                  </a>
                </div>*/}
                <h2 style={styles.headline}>Summary</h2>
                <Paper
                  zDepth={0}
                  style={styles.paper}
                >
                  <SummaryCard />
                </Paper>
                <h2 style={styles.headline}>Skills</h2>
                <Paper
                  zDepth={0}
                  style={styles.paper}
                >
                  <SkillCard />
                </Paper>
                <h2 style={styles.headline}>References</h2>
                <Paper
                  zDepth={0}
                  style={styles.paper}
                >
                  <ReferencesCard />
                </Paper>
              </div>
              <div className="no-overflow-x">
                <div className="single-link">
                  <SimpleLinkButton
                    gotoResume={()=>this.gotoResume()}
                    gotoResumeExpanded={()=>this.gotoResumeExpanded()}
                    gotoPDF={()=>this.gotoPDF()}
                  />
                </div>
                <h2 style={styles.headline}>Experience</h2>
                <Paper
                  zDepth={0}
                  style={styles.paper}
                >
                  <div
                    style={this.state.slideIndex!==1?styles.hidden:styles.none}
                  >
                    <Experience />
                  </div>
                </Paper>
              </div>
              <div className="no-overflow-x">
                <div className="single-link">
                  <SimpleLinkButton
                    gotoResume={()=>this.gotoResume()}
                    gotoResumeExpanded={()=>this.gotoResumeExpanded()}
                    gotoPDF={()=>this.gotoPDF()}
                  />
                </div>
                <h2 style={styles.headline}>Education</h2>
                <Paper
                  zDepth={0}
                  style={styles.paper}
                >
                  <div
                    style={this.state.slideIndex!==2?styles.hidden:styles.none}
                  >
                    <Education />
                  </div>
                </Paper>
              </div>

            </SwipeableViews>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js